export default {
      id: "loader-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#loader",
      toString: function () {
        return this.url;
      }
    }